import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDealer } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';
import type { CreateDealerPayload, Dealer } from '../types/dealers.types';

export const useCreateDealerMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<Dealer, unknown, CreateDealerPayload>({
        mutationFn: (payload) => createDealer(payload),
        onSuccess: () => {
            // Bust the dealer list cache so the new dealer appears in the search/list.
            queryClient.invalidateQueries({ queryKey: dealerKeys.lists() });
        },
    });
};
